import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { PaymentMethodsContent } from 'client/contents/PaymentMethodsContent/PaymentMethodsContent'

type TProps = {}

const PaymentMethodsPage: FC<TProps> = () => {
  return (
    <article className="flex w-full flex-col bg-surface-white">
      <AppHead />
      <PaymentMethodsContent />
    </article>
  )
}

export default PaymentMethodsPage
